import axios from "@/api/axiosInstance";
import { AdoptionConnection } from "../getAdoptionConnections/types";
import {
  UpdateConnectionAttributionRequest,
  UpdateConnectionAttributionResponse,
} from "./types";

export const updateConnectionAttribution = async (
  uuid: string,
  requestData: UpdateConnectionAttributionRequest,
): Promise<AdoptionConnection> => {
  const response = await axios.patch<UpdateConnectionAttributionResponse>(
    `/api/private/admin/data-connector-adoption/connections/${uuid}/attribution`,
    requestData,
  );
  return response.data.data;
};
